export default class Api {
    static baseURL = `https://games.vivogolftour.com`;

    static token() {
        return localStorage.getItem("vg_token");
    }

    static baseHeaders() {
        const token = this.token();
        return {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {})
        };
    }

    static get(url: string) {
        return fetch(this.baseURL + url, {
            method: "GET",
            headers: this.baseHeaders()
        });
    }

    static post(url: string, body: any) {
        return fetch(this.baseURL + url, {
            method: "POST",
            headers: this.baseHeaders(),
            body: JSON.stringify(body)
        });
    }

    static put(url: string, body: any) {
        return fetch(this.baseURL + url, {
            method: "PUT",
            headers: this.baseHeaders(),
            body: JSON.stringify(body)
        });
    }

    static delete(url: string) {
        return fetch(this.baseURL + url, {
            method: "DELETE",
            headers: this.baseHeaders()
        });
    }
}
